module.exports = __webpack_public_path__ + "static/media/accessControlBuilding_45.933be453.png";